/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'http-policy-set';
const componentName = 'http-policy-set-list';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const columnTitleTotalSecurityRules = `${prefix}.columnTitleTotalSecurityRules`;
export const columnTitleTotalRequestRules = `${prefix}.columnTitleTotalRequestRules`;
export const columnTitleTotalResponseRules = `${prefix}.columnTitleTotalResponseRules`;

export const ENGLISH = {
    [headerLabel]: 'HTTP Policy Set',
    [columnTitleTotalSecurityRules]: '# Security Rules',
    [columnTitleTotalRequestRules]: '# Request Rules',
    [columnTitleTotalResponseRules]: '# Response Rules',
};
